import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'shared/api';

import { ListingSearchResponse } from './listingSchema';

export const getWhereSearchQueryKey = (value: string) => {
  return ['where', 'search', value];
};

const getWhereSearch = async (value: string): Promise<ListingSearchResponse> => {
  const { data } = await apiClient.get('/listing/search', {
    value,
  });

  return data.result;
};

export const useGetWhereSearch = (value: string) => {
  const [debounceValue, setDebounceValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(value);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return useQuery({
    queryKey: getWhereSearchQueryKey(debounceValue),
    queryFn: () => getWhereSearch(debounceValue),
  });
};
